import * as React from "react";
import { connect } from "react-redux";

import { Nav, NavItem, NavItemDropdown } from "./CustomNav.styles";
// temp icon
import logo from "../../assets/images/plex_new.png";

import {
  clearSessionData,
  isUserLoggedIn,
  currentUser,
  currentDesignation,
  userFirstName,
  currentAvatar,
  getUserInitials,
} from "../../common/services";
import { Redirect } from "react-router-dom";
import withServices from "../../HOCs/withServices";
import { toast } from "react-toastify";
import avatarIcon from "../../assets/images/avatar.png";

interface IProps {
  logoutParent?: any;
  profileParent?: any;
  onMessages?: any;
  onReports?: any;
  history?: any;
  designation?: string;
  profileChildren?: any;
  progressParent?: any;
  services?: any;
  dispatch?: any;
  onLogoClick?: any;
}

interface IState {
  toLogin: boolean;
}

class CustomNav extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = { toLogin: false };
    this.onNavItemClick = this.onNavItemClick.bind(this);
  }
  public onNavItemClick(dest) {
    // handle navItem click
    const { history } = this.props;
    let destination = "";
    if (dest === "signup") {
      destination = "/onboarding/register/student";
    }
    if (dest === "signin") {
      destination = "/login";
    }
    history.push(destination);
  }

  public handleLogout = (event) => {
    clearSessionData();
    console.log("Nav", this.props);
    this.props.dispatch({ type: "CLEAR_STORE" });
    this.props.logoutParent();
  };
  public logoClickHandler = () => {
    // this.setState({toLogin: true});
    if (!this.props.onLogoClick) {
      this.setState({ toLogin: true });
    } else {
      console.log("no nav action....");
    }
  };
  public handleMessages = (event) => {
    if (this.props.onMessages) {
      this.props.onMessages();
    } else {
      console.log("Method not implemented");
    }
  };

  public handleReports = (event) => {
    if (this.props.onMessages) {
      this.props.onReports();
    } else {
      console.log("Method not implemented");
    }
  };

  public userItems = () => {
    console.log("currentAvatar", currentAvatar());
    if (isUserLoggedIn()) {
      return (
        <React.Fragment>
          <NavItemDropdown alignSelf="right">
            <div className="dropdown">
              {currentAvatar() === "" ||
              typeof currentAvatar() === "undefined" ||
              currentAvatar() === "default_avatar.png" ? (
                <img style={{ borderRadius: "30%" }} src={avatarIcon} />
              ) : (
                <img
                  style={{ borderRadius: "30%" }}
                  src={`${currentAvatar()}`}
                />
              )}

              <p>{currentUser()}</p>
            </div>
            <div className="dropdown-content-wrapper">
              <div className="dropdown-pointer" />
              <div className="dropdown-content">
                <NavItem
                  visible={!this.props.profileParent}
                  onClick={this.props.profileParent}
                >
                  <i className="fa fa-cog" aria-hidden="true" />
                  <p>Profile</p>
                </NavItem>

                <NavItem onClick={this.handleLogout}>
                  <i className="fa fa-sign-out" aria-hidden="true" />
                  <p>Logout</p>
                </NavItem>
              </div>
            </div>
          </NavItemDropdown>
        </React.Fragment>
      );
    } else {
      return "";
    }
  };
  public parentItems = () => {
    if (currentDesignation() === "parents") {
      return (
        <React.Fragment>
          <div className="no-dropdown">
            <NavItem
              visible={!this.props.profileChildren}
              onClick={this.props.profileChildren}
            >
              <i className="fa fa-pie-chart" aria-hidden="true" />
              <p>RESULTS</p>
            </NavItem>
            <NavItem visible={!this.props.progressParent}>
              <i className="fa fa-tasks" aria-hidden="true" />

              <p>PL PROGRESS</p>
            </NavItem>
          </div>
        </React.Fragment>
      );
    } else {
      return "";
    }
  };
  public adminItems = () => {
    if (currentDesignation() === "admins") {
      return (
        <div className="no-dropdown">
          <NavItem
            visible={!this.props.onMessages}
            onClick={this.handleMessages}
          >
            <i className="fa fa-envelope-o" aria-hidden="true" />
            <p>MESSAGES</p>
          </NavItem>
          <NavItem visible={!this.props.onReports} onClick={this.handleReports}>
            <i className="fa fa-file-text" aria-hidden="true" />

            <p>REPORTS</p>
          </NavItem>
        </div>
      );
    } else {
      return "";
    }
  };

  public render() {
    const { designation } = this.props;
    let navContent = null as any;
    if (designation === "onboarding") {
      navContent = (
        <React.Fragment>
          <div className="no-dropdown">
            <NavItem>
              <i className="fa fa-leanpub" aria-hidden="true" />
              <p>Plexing</p>
            </NavItem>
          </div>

          <NavItemDropdown>
            <div className="dropdown">
              <i className="fa fa-suitcase" aria-hidden="true" />
              <p>Resources</p>
            </div>
            <div className="dropdown-content-wrapper">
              <div className="dropdown-pointer" />
              <div className="dropdown-content">
                <NavItem>
                  <a
                    href="https://myperformancelearning.com/podcasts/"
                    target="_blank"
                  >
                    <i className="fa fa-headphones" aria-hidden="true" />
                    <p>Podcasts</p>
                  </a>
                </NavItem>
              </div>
            </div>
          </NavItemDropdown>
          <NavItemDropdown>
            <div className="dropdown">
              <i className="fa fa-user-circle" aria-hidden="true" />
              <p>Settings</p>
            </div>
            <div className="dropdown-content-wrapper">
              <div className="dropdown-pointer" />
              <div className="dropdown-content">
                <NavItem onClick={this.onNavItemClick.bind(this, "signup")}>
                  <i className="fa fa-sign-in" aria-hidden="true" />
                  <p>Sign Up</p>
                </NavItem>
                <NavItem onClick={this.onNavItemClick.bind(this, "signin")}>
                  <i className="fa fa-user-plus" aria-hidden="true" />
                  <p>Sign In</p>
                </NavItem>
              </div>
            </div>
          </NavItemDropdown>
        </React.Fragment>
      );
    }
    if (this.state.toLogin) {
      return <Redirect to="/" />;
    }
    return (
      <Nav>
        <div className="no-dropdown">
          <NavItem onClick={this.logoClickHandler}>
            <img src={logo} alt="" className="onboard-logo" />
          </NavItem>
        </div>
        <div className="nav-items-container">
          {designation === "onboarding" ? navContent : ""}
          {this.parentItems()}
          {this.adminItems()}
        </div>
        {this.userItems()}
      </Nav>
    );
  }
}

export default connect(null)(CustomNav);



// WEBPACK FOOTER //
// ./src/components/CustomNav/CustomNav.Component.tsx